module.exports = __webpack_public_path__ + "static/media/video-abstract-bg.3a49672a.mp4";